function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#4B5967",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.5 8h10M11.5 3.733L15.5 8l-4 4.267M8.5 15.467h-7c-.552 0-1-.478-1-1.067V1.6c0-.589.448-1.067 1-1.067h7"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _ref);

export default __webpack_public_path__ + "static/media/logout.ae05da48.svg";
export { SvgComponent as ReactComponent };